import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './routes/Home';
import Register from './routes/Register';
import VerifyCode from './routes/VerifyCode';
import Login from './routes/Login';
import Dashboard from './routes/Dashboard';
import CheckoutSuccess from './routes/CheckoutSuccess';
import CheckoutCancel from './routes/CheckoutCancel';

function AppRoutes() {
	return (
		<Router>
			<div>
				<main>
					<Routes>
						<Route path="/" element={<Home />} />
						<Route path="/register" element={<Register />} />
						<Route path="/login" element={<Login />} />
						<Route path="/verify-code" element={<VerifyCode />} />
						<Route path="/dashboard" element={<Dashboard />} />
						<Route path="/success" element={<CheckoutSuccess />} />
						<Route path="/cancel" element={<CheckoutCancel />} />
					</Routes>
				</main>
			</div>
		</Router>
	);
}

function App() {
	return (
		<AppRoutes />
	);
}

export default App;
